// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";

var wrapper = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.height("auto")]);

var Styles = {
  wrapper: wrapper
};

function ContentCard__TopContainer(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    wrapper,
                    className$1
                  ])
            });
}

var make = ContentCard__TopContainer;

export {
  Styles ,
  make ,
}
/* wrapper Not a pure module */
